/**
 * Created by zed on 2021/12/7
 * Copyright © 2017 www.moemone.com. All rights reserved.
 *
 * 配置文件
 */

const settingsModule = process.env.VUE_APP_SETTINGS_MODULE
let loadedModule = {}

if (settingsModule) {
  try {
    loadedModule = require(`./modules/${settingsModule}`)
    console.log(`[Settings] Loaded module: ${settingsModule}`)
  } catch (e) {
    console.error(`[Settings] Failed to load module: ${settingsModule}`, e)
  }
} else {
  console.warn('[Settings] No VUE_APP_SETTINGS_MODULE environment variable defined.')
}

export const IMAGES = loadedModule.IMAGES
export const NAV_ITEMS = loadedModule.NAV_ITEMS
export const FOOTER_ITEMS = loadedModule.FOOTER_ITEMS
export const QRCODE_ITEMS = loadedModule.QRCODE_ITEMS
export const DOWNLOAD_LINK = loadedModule.DOWNLOAD_LINK
export const URL = loadedModule.URL
